<template>
  <div>
    <report-base 
      :reports="listLinkDowloadCSV"
      type="accounting"
      reportBtnWidth="300px"
      containerWidth="600px"
      singleDate
    />
  </div>
</template>

<script>
import ReportBase from './reportBase.vue';

export default {
  name: 'ReportTotal',
  components: {ReportBase},
  data() {
    return {
      listLinkDowloadCSV: [
        {
          title: '残権利一覧',
          type: 'RemainingRights',
        },
      ],
    };
  },
};
</script>
